import MenuIcon from '@mui/icons-material/Menu';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import { IconButton, Menu } from '@mui/material';
import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  checkAccessAdministrator,
  checkAccessResponsible,
  checkAccessUser,
  checkRoleFi,
} from '../../helpers/utils/RoleManager';
import LinkMenuHeader from './LinkMenuHeader.jsx';

const MenuHeader = (props) => {
  const { profile } = props;
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton
        id="menu-button"
        size="large"
        edge="start"
        color="inherit"
        onClick={handleClick}
        sx={{ mr: 2 }}
      >
        {open ? <MenuOpenIcon /> : <MenuIcon />}
      </IconButton>
      <Menu
        id="user-menu"
        anchorEl={anchorEl}
        open={open}
        color="secondary"
        onClose={handleClose}
      >
        {checkAccessAdministrator(profile) ? (
          <LinkMenuHeader
            RouterLink={RouterLink}
            handleClose={handleClose}
            uri="/admin"
            name="Admin"
          />
        ) : null}
        {checkAccessUser(profile) ? (
          <LinkMenuHeader
            RouterLink={RouterLink}
            handleClose={handleClose}
            uri="/stats"
            name="Statistiques"
          />
        ) : null}
        {checkAccessResponsible(profile) ? (
          <LinkMenuHeader
            RouterLink={RouterLink}
            handleClose={handleClose}
            uri="/dashboard-sc"
            name="Service Client"
          />
        ) : null}
        {checkRoleFi(profile) || checkAccessAdministrator(profile) ? (
          <LinkMenuHeader
            RouterLink={RouterLink}
            handleClose={handleClose}
            uri="/dashboard-fi"
            name="Service Finance"
          />
        ) : null}
        {checkAccessAdministrator(profile) ? (
          <LinkMenuHeader
            RouterLink={RouterLink}
            handleClose={handleClose}
            uri="/dashboard-order"
            name="Commandes"
          />
        ) : null}
        {/* TODO: uncoment when feature is complete */}
        {checkAccessResponsible(profile) ? (
          <LinkMenuHeader
            RouterLink={RouterLink}
            handleClose={handleClose}
            // disabled={true}
            uri="/dashboard-template"
            name="Templates"
          />
        ) : null}
        {checkAccessUser(profile) ? (
          <LinkMenuHeader
            RouterLink={RouterLink}
            handleClose={handleClose}
            uri="/inbox"
            name="Inbox"
          />
        ) : null}
        {checkAccessResponsible(profile) ? (
          <LinkMenuHeader
            RouterLink={RouterLink}
            handleClose={handleClose}
            uri="/categorizations"
            name="Mapping"
          />
        ) : null}
      </Menu>
    </>
  );
};

export default MenuHeader;
